<div class="buttons-bar">
  <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<h2 mat-dialog-title>{{ "dialog.alertsHistory.title" | translate }}</h2>

<ui-alert [options]="{ type: 'info' }">{{ "dialog.alertsHistory.info" | translate }}</ui-alert>

<div mat-dialog-content>
  <table>
    <thead>
      <tr>
        <th>{{ "table.date" | translate }}</th>
        <th>{{ "table.moment" | translate }}</th>
        <th *ngFor="let component of data.outdatedAlerts[0].originalComponents">{{ component.name }}</th>
        <th>{{ "table.level" | translate }}</th>
        <th>{{ "table.resultsPractitionner" | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let alert of data.outdatedAlerts">
        <td>{{ alert.originalIssued | safeDate : "short" }}</td>
        <td>{{ alert.originalComponents[0].effectiveTiming ?? "-" }}</td>
        <td *ngFor="let comp of alert.originalComponents">
          {{ comp.value }}
        </td>
        <td>
          <mat-icon class="custom-icon-small" [ngClass]="alert.originalComponents[0].relatedAlerts[0] | alertLevelClass"
            >notifications</mat-icon
          >
        </td>
        <td>{{ alert.originalComponents[0].relatedAlerts[0].resultsPractitionner ?? "-" }}</td>
      </tr>
    </tbody>
  </table>
</div>
